import styled from 'styled-components';
import { device, fadeIn, font } from '@/styles/template';

export const ResultH2 = styled.h2`
    color: ${props => props.theme.semantic.text.primary};
    ${font.mobile.h2};
    text-align: center;
    @media ${device.tablet} {
      ${font.desktop.h3};
      text-align: left;
    }
`

export const ResultH3 = styled.h3`
    color: ${props => props.theme.semantic.text.primary};
    ${font.basicBoldS};
    text-align: center;
    
    @media ${device.tablet} {  
      ${font.mobile.h4};
      text-align: left;
    }
`

export const ResultDescriptionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  width: 100%;
  padding: 3rem 0;
  justify-items: stretch;
  justify-content: space-between;

  @media ${device.tablet} {
    grid-template-columns: minmax(400px, 760px) 250px;
    gap: 4rem;
    padding: 6rem 0;
  }
`;

export const ResultMainWrap = styled.main`
  background: ${props => props.theme.semantic.surface.primary};
`;

export const Wrap = styled.div`
  animation: ${fadeIn} 1s cubic-bezier(0.280, 0.840, 0.420, 1);
  color: ${props => props.theme.semantic.text.primary};
`;

